export const PRIMARY_COLOR = '#fa6146';
export const PRIMARY_LIGHT_COLOR = '#fdcbc2';

export const GREEN_COLOR = 'rgba(23, 163, 152, 1)';
export const RED_COLOR = 'rgba(231,29,54,1)';

export const BORDER_GREY_COLOR = 'rgba(232, 236, 238, 1)';
